<template>
  <v-card flat>
    <v-list>
      <v-list-item>
        <v-list-item-icon>
          <v-icon large>mdi-account-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Firdavs Beknazarov
          </v-list-item-title>
          <v-list-item-subtitle>SEO of SSASS Comapany</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <slot name="actions" />
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">E00001</v-list-item-title>
          <v-list-item-subtitle>Status</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action style="width: 200px">
          <v-progress-linear color="success" background-color="white" height="10"
            style="border: 1px solid rgba(74, 188, 136,0.76); margin-top: 10px"
            v-bind:value="70" striped />
          <v-list-item-action-text>Received 7 000 000 of 13 000 000</v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <slot />
  </v-card>
</template>
<script>
export default {
  name: 'v-salary-view',
}
</script>
